import { useMutation, useQueryClient } from "@tanstack/vue-query";
import PhoneNumber from "@/services/phone-number";
import { invalidateBillingQueries } from "@/composables/billing";

export function useDeletePhoneNumber() {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: async (phoneNumberIds: string | string[]) => {
      const ids = Array.isArray(phoneNumberIds) ? phoneNumberIds.join(",") : phoneNumberIds;
      const result = await PhoneNumber.deletePhoneNumber(ids);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete phone number");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["phoneNumbers"] });
      invalidateBillingQueries(queryClient);
    },
  });

  return {
    deletePhoneNumber: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
    deleteError: deleteMutation.error,
  };
}
